let _ = t => t,
  _t,
  _t2,
  _t3;
import styled from 'styled-components';
import { fontSize, fontWeights } from '@ovpn-ui/styles';
export const SidebarFooter = styled.div(_t || (_t = _`
    position: absolute;
    bottom: 0;
    left: 0;

    flex-grow: 0;
    flex-shrink: 0;

    width: 100%;
    padding: 24px 15px 24px 14px;

    color: ${0};

    background-color: ${0};

    &::before {
        position: absolute;
        top: 0;
        left: 5%;

        display: block;
        width: 90%;
        height: 1px;

        background: ${0};

        content: ' ';
    }
`), t => t.theme.text, t => t.theme.bg, t => t.theme.border);
export const SidebarFooterLink = styled.a(_t2 || (_t2 = _`
    display: block;
    margin: 10px 0;
    padding: 8px 0px;

    color: ${0};
    font-weight: ${0};
    font-size: ${0};
    line-height: ${0};
    white-space: nowrap;
    text-align: center;
    text-decoration: none;

    background-color: ${0};
    border-radius: 4px;
    cursor: pointer;

    user-select: none;
`), t => t.theme.text, fontWeights.medium, fontSize.small, fontSize.xMedium, t => t.theme.itemHoverColor);
export const SidebarFooterText = styled.p(_t3 || (_t3 = _`
    margin: 0;
    padding: 10px 0;

    color: ${0};
    font-size: ${0};
    text-align: center;
`), t => t.theme.text, fontSize.small);